import { MixteDay } from '../../domain/collection/activity/Mixte.types';
import { ComputedMixteDay } from './MixteDaysComputator.types';

export default abstract class MixteDaysComputator {
  // eslint-disable-next-line no-unused-vars
  constructor(protected mixteDays: MixteDay[]) {}

  abstract compute(): ComputedMixteDay[];
}
